export default __webpack_public_path__ + "assets/images/5984f71c17043d86ad8529bff9ac562e.svg";